var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import History from "@irati/utils/history";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import padding from "@irati/ui/src/global/padding";
import { Para as ParaBase } from "@irati/ui/src/Labels";
import ButtonBase from "@irati/ui/src/Button";
import { H2 } from "@irati/ui/src/Headings";
import Modal from "@irati/ui/src/Modal";
import modalImage from "../../images/ghost.png";
var Para = styled(ParaBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", " 0 ", ";\n"], ["\n  margin: ", " 0 ", ";\n"])), padding.small, padding.large);
var Button = styled(ButtonBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var ErrorPopup = /** @class */ (function (_super) {
    __extends(ErrorPopup, _super);
    function ErrorPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: true
        };
        _this.handleHide = function () { return _this.setState({
            show: false
        }); };
        _this.handleAfterExit = function () {
            History.push("/reward", _this.context);
        };
        _this.handleClick = function () {
            History.push("/reward", _this.context);
        };
        return _this;
    }
    ErrorPopup.prototype.render = function () {
        var show = this.state.show;
        return (React.createElement(Modal, { show: show, image: modalImage, onHide: this.handleHide, onExited: this.handleAfterExit },
            React.createElement(H2, null,
                React.createElement(FormattedMessage, { id: "reward.popup.error.title" })),
            React.createElement(Para, { large: true, center: true },
                React.createElement(FormattedMessage, { id: "reward.popup.error.description" })),
            React.createElement(Button, { primary: true, type: "button", onClick: this.handleClick },
                React.createElement(FormattedMessage, { id: "reward.popup.error.button.label" }))));
    };
    ErrorPopup.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return ErrorPopup;
}(PureComponent));
export default injectIntl(ErrorPopup);
var templateObject_1, templateObject_2;
